import { render, staticRenderFns } from "./CompanyMergeProvider.vue?vue&type=template&id=04cc5136&scoped=true&"
import script from "./CompanyMergeProvider.vue?vue&type=script&lang=ts&"
export * from "./CompanyMergeProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc5136",
  null
  
)

export default component.exports